import { createTheme, type ThemeOptions } from '@mui/material/styles';
import { colors } from './colors.js';

export { SCRIPTPAD_LOGO_URL, SCRIPTPAD_ICON_URL } from './brand.js';

const fontStack =
  '"Manrope", "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: { main: colors.primary, dark: colors.primaryDark, light: colors.primaryLight, contrastText: '#ffffff' },
    secondary: { main: colors.yellow, contrastText: colors.navy },
    success: { main: colors.green },
    error: { main: colors.red },
    text: { primary: colors.navy, secondary: colors.darkGrey },
    background: { default: colors.bgWash, paper: '#ffffff' },
    divider: colors.border,
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: fontStack,
    h1: { fontFamily: '"Manrope", sans-serif', fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontFamily: '"Manrope", sans-serif', fontWeight: 800, letterSpacing: '-0.02em' },
    h3: { fontFamily: '"Manrope", sans-serif', fontWeight: 700, letterSpacing: '-0.01em' },
    h4: { fontFamily: '"Manrope", sans-serif', fontWeight: 700 },
    h5: { fontFamily: '"Manrope", sans-serif', fontWeight: 700 },
    h6: { fontFamily: '"Manrope", sans-serif', fontWeight: 700 },
    button: { fontFamily: '"Manrope", sans-serif', fontWeight: 600, textTransform: 'none', letterSpacing: 0 },
    body1: { fontFamily: '"Open Sans", sans-serif', fontSize: '1rem', lineHeight: 1.6 },
    body2: { fontFamily: '"Open Sans", sans-serif', lineHeight: 1.6 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 999, paddingInline: 24, paddingBlock: 10, fontSize: '1rem' },
        sizeLarge: { paddingInline: 32, paddingBlock: 14, fontSize: '1.05rem' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: 16 },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', fullWidth: true },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 12 },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: { '&.Mui-active': { color: colors.primary }, '&.Mui-completed': { color: colors.primary } },
      },
    },
  },
};

export const scriptPadTheme = createTheme(themeOptions);
